/* eslint-disable */
import { useEffect, useState } from 'react';
import { isClient } from './util';

var useLocalStorage = function useLocalStorage(key, initialValue, options) {
  if (!isClient) {
    return [initialValue, function () {}];
  } // Use provided serializer/deserializer or the default ones


  var serializer = options ? options.raw ? String : options.serializer : JSON.stringify;
  var deserializer = options ? options.raw ? String : options.deserializer : JSON.parse;

  var _a = useState(function () {
    try {
      var localStorageValue = localStorage.getItem(key);

      if (localStorageValue !== null) {
        return deserializer(localStorageValue);
      } else {
        initialValue && localStorage.setItem(key, serializer(initialValue));
        return initialValue;
      }
    } catch (_a) {
      // If user is in private mode or has storage restriction
      // localStorage can throw. JSON.parse and JSON.stringify
      // can throw, too.
      return initialValue;
    }
  }),
      state = _a[0],
      setState = _a[1];

  useEffect(function () {
    try {
      localStorage.setItem(key, serializer(state));
    } catch (_a) {// If user is in private mode or has storage restriction
      // localStorage can throw. Also JSON.stringify can throw.
    }
  }, [state]);
  return [state, setState];
};

export default useLocalStorage;